if (!window.GetPageTemplate) {
    function GetPageTemplate(ptName) {
        var f = $.f || {};
        return f[ptName] || ('Could not find js page template ' + ptName);
    }
}

if (!window.toMoney) {
    window.toMoney = window.convertMoney.toMoney;
}

if (!window.noticeError) {
    function noticeError(e) {
        window.app && window.app.NRNoticeError && window.app.NRNoticeError(e);
    }
}

(function(win) {
    app.settings.ready(function (s) {
        win.__useGuestCheckout__ = app.settings.get('UseGuestCheckout');
        win.__isAuthorized__ = !(app.cookie.get('us') === null || app.cookie.get('us') === 'unl');
    });
})(window);

function IsAuthorized() {
    if (window.isAuthorized == null) {
        if (!app.settings.get('UseGuestCheckout')) {
            window.isAuthorized = true;
        } else {
            window.isAuthorized = !(app.cookie.get('us') === null || app.cookie.get('us') === 'unl');
        }
    }
    return window.isAuthorized;
}

function DisplayEmbeddedLoginForm() {
    var generalSettings = app.settingsUtils.getSiteDataGeneralSection();
    var isAuthorized = !(app.cookie.get('us') === null || app.cookie.get('us') === 'unl');
    return app.settings.get('UseEmbeddedLoginForm') && !generalSettings.UseGuestCheckout && !isAuthorized;
}

(function (app) {
    var _isAuthorized = !(app.cookie.get('us') === null || app.cookie.get('us') === 'unl');
    app.event = app && app.events && app.events.initCheckoutEvents(!_isAuthorized, false);
})(window.app);

var LocalStorageSyncer = (function () {
    var S = function (key, cb) {
        this._key = key;
        this._cb = _.isFunction(cb) && cb || $.noop;
        this._event = 'storage.' + key;

        $(window).on(this._event, _.bind(this._onStorage, this));
    };

    _.extend(S.prototype, {
        kill: function () {
            $(window).off(this._event);
        },

        set: function (data) {
            window.localStorage && window.localStorage.setItem(this._key, JSON.stringify(data));
        },

        get: function () {
            return window.localStorage && window.localStorage.getItem(this._key);
        },

        _onStorage: function (e) {
            var key = e && e.originalEvent && e.originalEvent.key;

            if (!key || key !== this._key) {
                return;
            }

            var data = this.get();

            if (!data) {
                return;
            }

            try {
                var parsed = JSON.parse(data);
            } catch (e) {
                // Silent...
            }

            this._cb(parsed);
        }
    });

    return S;
})();

var CheckoutSettings = {
    getBasketSettings: function () {
        var settings = $('@basket').data('settings') || {};
        if (!IsAuthorized()) {
            settings.UseIPay = false;
            settings.UseMasterPass = false;
        }
        settings.IsStripeEnabled = function() {
            var isAvailabled = !!app.models.availablePaymentOptions.where({ Name: 'Stripe' }).length;
            return settings.StripeEnabled && isAvailabled;
        };

        return settings;
    },

    getDecoration: function () {
        var data = $('@basket').data('decoration') || {};
        return data.DecorationInfo;
    },

    termsAndConditions: {
        isEnabled: function () {
            return CheckoutSettings.getBasketSettings().TermsAndConditionsMode > 0;
        },

        isCheckboxSelected: function () {
            return CheckoutSettings.getBasketSettings().TermsAndConditionsMode === 2;
        }
    },

    OrderPaymentType: {
        None: 'None',
        IpPayments: 'IpPayments',
        PayPalExpress: 'PayPalExpress',
        PayPalWebPro: 'PayPalWebPro',
        TNSPayments: 'TNSPayments',
        NabPayments: 'NabPayments',
        KPayments: 'KPayments',
        MasterPassPayment: 'MasterPassPayment',
        IPay88Payments: 'IPay88Payments',
        CyberSourcePayments: 'CyberSourcePayments',
        ENetsPayments: 'ENetsPayments',
        CashflowsPayments: 'CashflowsPayments',
        PayPalEbay: 'PayPalEbay',
        BrainTree: 'BrainTree',
        BrainTreePayPal: 'BrainTreePayPal',
        VisaCheckoutBrainTree: 'VisaCheckoutBrainTree',
        VisaCheckoutCyberSource: 'VisaCheckoutCyberSource',
        GraysEcommerce: 'GraysEcommerce',
        PromoVoucher: 'PromoVoucher',
        RefundVoucher: 'RefundVoucher',
        ImportedFromBIV: 'ImportedFromBIV',
        MyPay: 'MyPay',
        Stripe: 'Stripe'
    },

    PaymentOption: {
        None: 'None',
        MasterPassPayment: 'MasterPassPayment',
        IPay88Payments: 'IPay88Payments',
        BrainTree: 'BrainTree',
        BrainTreePayPal: 'BrainTreePayPal',
        BrainTreePayPalCredit: 'BrainTreePayPalCredit',
        VisaCheckoutBrainTree: 'VisaCheckoutBrainTree',
        VisaCheckoutCyberSource: 'VisaCheckoutCyberSource',
        MyPay: 'OurPay',
        Afterpay: 'Afterpay',
        Openpay: 'Openpay',
        Humm: 'Humm',
        ZipPayAU: 'ZipPayAU',
        ZipPayNZ: 'ZipPayNZ',
        LPay: 'LatitudePay',
        Klarna: 'Klarna'
    },

    PaymentSystemType: {
        braintree: 'braintree',
        mypay: 'mypay',
        stripe: 'stripe'
    },

    MyPayRejectionCodes: {
        outOfRange: 'mypay_payment_amount_out_of_range',
        exceededDebtLimit: 'mypay_customer_exceeded_debt_limit',
        untrusted: 'mypay_customer_untrusted',
        invalidPaymentMethod: 'mypay_invalid_payment_method'
    },

    SpinnerTimeout: 2000
};

var MyPayTransactionsView = Backbone.View.extend({

    className: 'schedule-container test-mypay-transactions',

    initialize: function (opts) {
        this._convertMoney = opts.convertMoney || window.convertMoney;
        this._currencySign = opts.currencySign || GlobalSettings.CurrencySign;
        this.render();
        this.$el.attr('role', 'myPayBillingPlan');
        this.$el.addClass(opts.type || 'medium');
        this.$el.hide();
    },

    render: function () {
        var transactions = this.collection;
        var total = 0;
        for (var i = 0; i < transactions.length; i++) {
            var transaction = transactions[i];
            var row = $('<div/>').addClass('schedule-row');
            row.append(this._createDate(transaction));
            row.append(this._createProgressLine(transaction, transactions.length));
            row.append(this._createStatus(transaction));
            this.$el.append(row);
            total += transaction.Amount;
        }
        this._renderTotal(total);
    },

    _renderTotal: function (total) {
        var row = $('<div/>').addClass('schedule-row');
        var totalText = this._convertMoney.toMoney(total, this._currencySign);
        var leftCell = $('<div/>').addClass('schedule-total').text(GetPageTemplate('_Total')),
            centerCell = $('<div/>').addClass('schedule-wrapper'),
            rightCell = $('<div/>').addClass('schedule-status').text(totalText);
        row.append(leftCell, centerCell, rightCell);
        this.$el.append(row);
    },

    _createProgressLine: function (transaction, transactionsCount) {
        var wrapper = $('<div />').addClass('schedule-wrapper');
        var cell = $('<div />').addClass('schedule-cell');
        var line = $('<div />')
            .addClass('schedule-line')
            .addClass('schedule-line__color_' + transactionsCount + '_' + transaction.Number);
        cell.append(line);
        wrapper.append(cell);

        for (var i = 1; i <= transactionsCount; i++) {
            cell.append(this._createCircle(transactionsCount, i, transaction.Number));
        }

        return wrapper;
    },

    _createCircle: function (transactionsCount, sequenceNumber, transactionNumber) {
        var circle = $('<div />')
            .addClass('schedule-circle')
            .addClass('schedule-circle_' + transactionsCount + '_' + sequenceNumber)
            .text(sequenceNumber);

        if (transactionNumber >= sequenceNumber) {
            circle.addClass('schedule-circle__color');
        }

        return circle;
    },

    _createDate: function (transaction) {
        var text = transaction.Number === 1 ?
            GetPageTemplate('_Today') :
            transaction.PlannedDate.getDateFromMS().format('dd mmm');
        return $('<div/>')
            .addClass('schedule-date')
            .text(text);
    },

    _createStatus: function (transaction) {
        var status = $('<div/>').addClass('schedule-status');
        var type = 'pedning';
        var text = this._convertMoney.toMoney(transaction.Amount, this._currencySign);

        if (transaction.State === 2) {
            type = 'paid';
            text = '<span class="paid-icon"></span>' + GetPageTemplate('_Paid');
        }

        return status.addClass(type).html(text);
    }
});

var ViewCheckoutPixelModule = function(){
    var ViewCheckoutPixel = function(){}

    _.extend(ViewCheckoutPixel.prototype, {
        view: function(collection){
            if (!Pixel || !Pixel.events) {
                return;
            }

            var items = collection.map(function(model){
                return model.toJSON();
            });

            Pixel.events.trigger('viewCheckout', {Items: items, Currency: app.Braintree.currencyIso});
        }
    });

    return ViewCheckoutPixel;
}

var PaymentInfoPixelModule = function(currency){
    var PaymentInfoPixel = function(){}

    _.extend(PaymentInfoPixel.prototype, {
        trigger: function(details, models) {

            var data = models.payment.getCurrentPaymentMethod();
            var collection = models.itemsList;
            var summary = models.summary;
            var orderInfoResult = details && details.Value && details.Value.OrderInfoResult;

            if(!data || !collection || !summary || !orderInfoResult){
                return;
            }

            if (!Pixel || !Pixel.events) {
                return;
            }

            Pixel.events.trigger('paymentInfo', _.extend({}, {
                Total: summary.get('Total'),
                PaymentType: data.PaymentType,
                Currency: app.Braintree.currencyIso,
                Items: collection.map(function(model){
                    model = model.toJSON();
                    model.SaleName = orderInfoResult && orderInfoResult.SaleName;
                    return model;
                }),
            }))
        }
    });

    return PaymentInfoPixel;
}

var PurchasePixelModule = function () {

    var PurchasePixel = function () { };

    _.extend(PurchasePixel.prototype, {
        confirmation: function (data, model) {
            var orderInfoResult = data && data.Value && data.Value.OrderInfoResult;

            if (!orderInfoResult || !model) {
                return;
            }

            if (!Pixel || !Pixel.events) {
                return;
            }

            Pixel.events.trigger('purchaseSuccess', _.extend({
                OrderInfoResult: orderInfoResult,
                paymentID: data.Value.PaymentID,
                orderNo: data.Value.invoiceNo || data.Value.InvoiceNo
            }, this._getAdditionalData(model)));
        },

        _getAdditionalData: function (model) {
            var itemsList = app.models.itemsList,
                data = {
                    pricesArr: itemsList.pluck('Price'),
                    productIDsArr: itemsList.map(function (m) { return kos.guidToBase64(m.get('ID')); }),
                    qtyArr: itemsList.pluck('Qty'),
                    discounts: itemsList.pluck('Discount')
                };
            return _.extend(data, {
                prices: data.pricesArr.join(','),
                productIDs: data.productIDsArr.join(','),
                totalQty: itemsList.reduce(function (result, m) { return m.get('Qty') + result; }, 0),
                totalValue: app.models.summary.get('Total'),
                revenue: app.models.summary.get('Subtotal'),
                discounts: data.discounts,
                currencyIso: app.Braintree.currencyIso,
            });
        }
    });

    return PurchasePixel;
};

var RemoveFromCartPixelModule = function(){
    var RemoveFromCartPixel = function(){}

    _.extend(RemoveFromCartPixel.prototype, {
        remove: function(app, model){

            if (!Pixel || !Pixel.events) {
                return;
            }

            Pixel.events.trigger('removeFromCart', 
                _.extend(model.toJSON(), {
                    Currency: app.Braintree.currencyIso,
                })
            );
        }
    });

    return RemoveFromCartPixel;
}

var ShippingInfoPixelModule = function(){
    var ShippingInfoPixel = function(){}

    _.extend(ShippingInfoPixel.prototype, {
        add: function(data)
        {
            if (!Pixel || !Pixel.events || !data) {
                return;
            }

            Pixel.events.trigger('addShippingInfo', {
                Items: data.Items, 
                Total: data.Summary.Total,
                Currency: app.Braintree.currencyIso
            });
        }
    });

    return ShippingInfoPixel;
}

var PhoneVerification = function () {

    var PhoneVerificationModel = Backbone.Model.extend({
        defaults: {
            PhoneMask: '^(\\+|\\+\\d|\\d)(-)?(\\(|\\(\\d+|\\(\\d+\\)|\\d+)?(-)?(\\d+|\\d+-||\\d+-\\d+)*(\\d+)?$',
            CodeMask: '\\d*',
            PhoneLength: 30,
            CodeLength: 4,
            Phone: '',
            Code: '',
            PhoneIsValid: true,
            CodeIsValid: true
        },
        normalizePhoneAndSendCode: function () {
            var that = this;
            if (this._isValid('Phone', 'PhoneIsValid')) {
                return app.checkout.normalizePhoneAndSendCode(this.getPhoneNumber())
                    .then(function (data) {
                        that.set('CountryCode', data.Value.CountryCode);
                        that.set('Phone', data.Value.Phone);
                        return new $.Deferred().resolve(data).promise();
                    });
            }
            return new $.Deferred().reject().promise();
        },
        resend: function () {
            if (this._isValid('Phone', 'PhoneIsValid')) {
                return app.checkout.normalizePhoneAndSendCode(this.getPhoneNumber())
            }
            return new $.Deferred().reject().promise();
        },
        confirm: function () {
            var isValid = this._isValid('Phone', 'PhoneIsValid');
            isValid = this._isValid('Code', 'CodeIsValid') && isValid;
            if (isValid) {
                return app.checkout.verificationCodeConfirm(this.getPhoneNumber(), this.get('Code'));
            }
            return new $.Deferred().reject().promise();
        },
        getPhoneNumber: function () {
            return this.getCountryCode() + this.get('Phone');
        },
        getPhone: function () {
            return this.get('Phone');
        },
        getCountryCode: function () {
            return this.get('CountryCode') ? ('+' + this.get('CountryCode')) : '';
        },
        setPhone: function (value) {
            this.set('Phone', value);
        },
        setCode: function (value) {
            this.set('Code', value);
        },
        _isValid: function (propertyName, validPropertyName) {
            var isValid = !!this.get(propertyName);
            this.set(validPropertyName, isValid);
            return isValid;
        }
    });

    var PhoneVerificationView = Backbone.View.extend({
        events: {
            'click @btnResendVerificationCode': '_normalizePhoneAndSendCode',
            'click @btnConfirmVerificationCode': 'confirm',

            'input @txtVerifyPhoneNumber': 'change', // Needed because 'keyup' event is not works properly for fast changes.
            'keyup @txtVerifyPhoneNumber': 'change', // Only for <=IE9.
            'keydown @txtVerifyPhoneNumber': '_keydownphone',
            'change @txtVerifyPhoneNumber': 'change',
            'mouseup @txtVerifyPhoneNumber': '_clearedByCross',

            'input @txtVerificationCode': 'change', // Needed because 'keyup' event is not works properly for fast changes.
            'keyup @txtVerificationCode': 'change', // Only for <=IE9.
            'keydown @txtVerificationCode': '_keydowncode',
            'change @txtVerificationCode': 'change',
            'mouseup @txtVerificationCode': '_clearedByCross'
        },

        initialize: function () {
            _.bindAll(this);

            var initdef = new $.Deferred();
            this.init = initdef.promise();

            this.$def = new $.Deferred();

            this.$el = ($.tmpl('phone-verification-form', this.model.toJSON()));

            this.$countryCode = this.$('@countryCode');

            this.$txtVerifyPhoneNumber = this.$('@txtVerifyPhoneNumber');

            this.$txtVerificationCode = this.$('@txtVerificationCode');

            this.$errorMessage = this.$('@verificationErrorMessage');

            this.model.on('destroy', this.remove);
            this.model.on('change:PhoneIsValid', this._phoneIsValid);
            this.model.on('change:CodeIsValid', this._codeIsValid);

            this.$txtVerifyPhoneNumber.keyFilter(this.model.get('PhoneLength'), this.model.get('PhoneMask'));
            this.$txtVerificationCode.keyFilter(this.model.get('CodeLength'), this.model.get('CodeMask'));

            this._normalizePhoneAndSendCode().always(initdef.resolve);
        },

        _clearedByCross: function (e) {
            var _this = this;
            if (e.currentTarget.value === "") return;
            setTimeout(function () {
                if (e.currentTarget.value === "") _this.change(e);
            }, 0);
        },

        change: function () {
            this.model.setPhone(this.$txtVerifyPhoneNumber.val());
            this.model.setCode(this.$txtVerificationCode.val());
        },

        _keydowncode: function (e) {
            e.stopPropagation();
            if (e.which === 13 || e.keyCode === 13) {
                this.confirm();
            }
        },

        _keydownphone: function (e) {
            e.stopPropagation();
        },

        getPromise: function () {
            return this.$def.promise();
        },

        _phoneIsValid: function () {
            this.$txtVerifyPhoneNumber.toggleClass('errorField', !this.model.get('PhoneIsValid'));
        },

        _codeIsValid: function () {
            this.$txtVerificationCode.toggleClass('errorField', !this.model.get('CodeIsValid'));
        },

        _normalizePhoneAndSendCode: function () {
            return this.model.normalizePhoneAndSendCode().done(this.resendResult);
        },

        resend: function (e) {
            return this.model.resend().done(this.resendResult);
        },

        resendResult: function (data) {
            this.$countryCode.text(this.model.getCountryCode());
            this.$txtVerifyPhoneNumber.val(this.model.getPhone());
            this.$errorMessage.text(data.Value.ErrorMessage);
        },

        confirm: function (e) {
            this.model.confirm().done(this.success);
        },

        success: function (data) {
            this.$errorMessage.text(data.Value.ErrorMessage);
            if (!data.Value.ErrorMessage && !data.Value.NotificationMessage) {
                this.$def.resolve();
            }

            if (data.Value.NotificationMessage) {
                this.$def.reject();
                kos.dialog.error({
                    message: data.Value.NotificationMessage
                });
                app.checkout.update_checkout();
            }
        },



        cancel: function (e) {
            this.$def.reject();
        }
    });

    var isPopupOpened = false;
    var openPopup = function (phone) {
        if (isPopupOpened) return new $.Deferred().reject();

        var settings = app.models.page.get('PhoneVerification');

        if (!settings || !settings.IsRequired) {
            var def = new $.Deferred();
            def.resolve();
            return def.promise();
        }

        isPopupOpened = true;

        var model = new PhoneVerificationModel({
            PhoneMask: settings.Fields.PhoneNumberFormat.Regexp,
            CodeMask: settings.Fields.VerificationCodeFormat.Regexp,
            PhoneLength: settings.Fields.PhoneNumberFormat.MaxLength,
            CodeLength: settings.Fields.VerificationCodeFormat.MaxLength,
            Phone: phone,
            Code: ''
        });
        var form = new PhoneVerificationView({ model: model });

        form.init.done(function () {
            var dialog = kos.dialog.popup({
                cls: 'verification-popup__position',
                title: 'Confirm your phone number',
                closeBtn: true,
                hideOnClick: false
            });

            dialog.$('.notifier-message').append(form.$el);

            form.$txtVerificationCode.focus();

            dialog.on('beforeHide', function () {
                model.destroy();
                isPopupOpened = false;
            });

            form.getPromise().always(dialog.destroy);
        });

        return form.getPromise();
    };

    return {
        openPopup: openPopup
    };
};

var PaymentModelValidator = (function () {

    var PaymentModelValidator = function (opts) {
        _.bindAll(this);
        $.extend(this, opts);
        this.$addressApply = new $.Deferred();
    };

    var _embidedAuthFormWarningDialog = null;

    var _deliveryPriceWasChanged = function (prev, curr, total) {

        var $deff = new $.Deferred();
        var msg = GetPageTemplate('_deliverySurchargeNotification');

        msg = msg.replace(/\[\[Previous\]\]/gi, window.convertMoney.toMoney(prev, GlobalSettings.CurrencySign));
        msg = msg.replace(/\[\[Current\]\]/gi, window.convertMoney.toMoney(curr, GlobalSettings.CurrencySign));
        msg = msg.replace(/\[\[Total\]\]/gi, window.convertMoney.toMoney(total, GlobalSettings.CurrencySign));

        var popup = kos.dialog.decisionPopup({
            message: msg,
            buttons: [
                {
                    'data-role': 'goToBasket',
                    text: 'Go back to checkout',
                    'class': 'price-changed-dialog-button price-changed-dialog-button__black'
                },
                {
                    'data-role': 'clearBasket',
                    text: 'Continue to pay',
                    'class': 'price-changed-dialog-button price-changed-dialog-button__green'
                }
            ]
        });
        popup.$el.addClass('price-changed-dialog');
        popup.on('click:goToBasket', function() {
            popup.destroy();
            $deff.reject();
        });
        popup.on('click:clearBasket', function () {
            popup.destroy();
            $deff.resolve();
        });

        return $deff.promise();
    };

    _.extend(PaymentModelValidator.prototype, {
        setIsAgreedWithTerms: function (flag) {
            this._isAgreedWithTermsFlag = flag;
        },

        _showIsAgreedPopup: function () {
            kos.dialog.popup({ title: GetPageTemplate('_CheckoutTermsAndConditionsValidationFailed') });
        },

        _isValidDelivery: function () {
            return app.models.delivery.isValid();
        },

        _isAgreedWithTerms: function () {
            return this._isAgreedWithTermsFlag;
        },

        _applyNewAddress: function () {
            var _basketMode = app.models.page.get('BasketMode');
            var delivery = app.models.summary.get('Delivery');

            if (_basketMode === 0) {
                return this.__applyGeneralAddress(delivery);
            }
            return this.__applyGiftAddress(delivery);
        },

        __applyGeneralAddress: function (delivery) {
            var $deferred = new $.Deferred();
            
            var decorationCollection = app.models.delivery.decoration;

            if (decorationCollection.isActive) {
                decorationCollection.save(_.bind(function (data) {
                    this.__saveAddressCallback(data, delivery, $deferred);
                }, this), $deferred.reject);
            } else {
                $deferred.resolve();
            }
            return $deferred.promise();
        },

        __applyGiftAddress: function (delivery) {
            var $deferred = new $.Deferred();

            var giftCollection = app.models.delivery.giftDecoration;
            var billingCollection = app.models.delivery.billingDecoration;
            var giftOccasion = app.models.giftOccasion;

            var _callback = _.bind(function(data) {
                this.__saveAddressCallback(data, delivery, $deferred);
            }, this);

            if (giftCollection.isActive && billingCollection.isActive) {
                var giftAddress = null;
                var billingAddress = null;
                if (giftCollection.isValid()) {
                    giftAddress = giftCollection.getAddress();
                }
                if (billingCollection.isValid()) {
                    billingAddress = billingCollection.getAddress();
                }
                if (giftAddress && billingAddress) {
                    var xhr;
                    if (IsAuthorized()) {
                        xhr = app.checkout.setUserGiftAndBillingAddress(giftAddress, billingAddress);
                    } else {
                        var data = giftCollection.getAuthData();
                        xhr = app.checkout.setPublicGiftAndBillingAddress(giftAddress, billingAddress, data);
                    }
                    $.when(xhr, giftOccasion.save()).done(_callback);
                }
            } else if (giftCollection.isActive) {
                giftCollection.save(function (data) {
                    giftOccasion.save();
                    _callback(data);
                }, $deferred.reject);
            } else if (billingCollection.isActive) {
                billingCollection.save(_callback, $deferred.reject);
            } else if (giftOccasion.hasChanges()) {
                giftOccasion.save().done($deferred.resolve);
            } else {
                $deferred.resolve();
            }

            return $deferred.promise();
        },

        __saveAddressCallback: function (data, delivery, $deferred) {
            if (!data.Value.NotificationMessage) {
                if (data.Value.Summary.Delivery === delivery) {
                    $deferred.resolve();
                } else {
                    var prev = delivery;
                    var cur = data.Value.Summary.Delivery;
                    var total = data.Value.Summary.TotalWithSelect;
                    _deliveryPriceWasChanged(prev, cur, total)
                        .done($deferred.resolve)
                        .fail($deferred.reject);
                }
            } else {
                $deferred.reject();
            }
        },

        _verifyBillingAddress: function (data) {
            var settings = CheckoutSettings.getBasketSettings();
            var $def = new $.Deferred();
            if (settings.BillingAddressEnabled) {
                var billing = app.models.delivery.billingAddress;
                billing._verify().done($def.resolve.bind($def, data));
            } else {
                $def.resolve(data);
            }
            return $def.promise();
        },

        process: function () {
            var $deferred = new $.Deferred();

            if (app.Braintree.hostedFields) {
                app.Braintree.hostedFields.clearValidation();
            }

            if (app.models.shipmentList.where({ 'ShippingAvailability': false }).length > 0) {
                $deferred.reject();
                kos.dialog.error({
                    message: GetPageTemplate('_ImpossibleToDeliverAtLocation_Message')
                });
                return $deferred.promise();
            }

            if (!this._isAgreedWithTerms()) {
                this._showIsAgreedPopup();
                $deferred.reject();
                return $deferred.promise();
            }

            var details = null;
            if (!IsAuthorized()) {
                details = app.getCustomerData();
            }

            if (!this._isValidDelivery()) {
                $deferred.reject();
                return $deferred.promise();
            }

            this.$addressApply = this._applyNewAddress()
                .then(this._verifyBillingAddress.bind(this));

            /* Check terms of ourpay select */
            if (app.models.delivery.options.isOurpaySelect()) {
                var selectedOption = app.models.delivery.options.where({ Selected: true })[0];
                if (selectedOption && !selectedOption.get('Purchased') && !selectedOption.get('AgreedWithTerms')) {
                    kos.dialog.error({
                        message: GetPageTemplate('_OurPaySelectTCValidationFailed')
                    });
                    return $deferred.reject().promise();
                }
            }

            if (!app.models.page.IsAgreeWithAgeRestricted()) {
                kos.dialog.error({
                    title: GetPageTemplate('_PleaseConfirmAgeRestrictedText')
                });
                $deferred.reject();
            }


            if (details) {

                this.$addressApply.done(function () {
                    if (!details.isValid) {
                        $deferred.reject();
                    } else {
                        $deferred.resolve();
                    }
                }).fail($deferred.reject);

            }
            else {
                $deferred.resolve();
            }

            return $deferred.promise();
        },
        getPhoneVerification: function () {
            if (!this.phoneVerification) {
                this.phoneVerification = new PhoneVerification();
            }
            return this.phoneVerification;
        },
        processPhoneVerification: function (force) {
            if (!!force || app.models.delivery.options.isOurpaySelect()) {
                return this.getPhoneVerification().openPopup(app.models.delivery.current.get('Phone'));
            }
            return new $.Deferred().resolve().promise();
        },

        addressVerification: function () {
            return this.$addressApply;
        },

        done: function (callback) {
            this.$addressApply.done(callback);
        }

    });

    return PaymentModelValidator;
})();